/* @flow */
import { createRef } from 'react'
import StepLib from 'atpjs/wizard/step'
import mapping from 'tve/stores/mapping'

import type { StepPropsType, StepStateType } from 'atpjs/wizard/step'

class Step<Props: StepPropsType, State: StepStateType> extends StepLib<Props, State> {
  sendData = true
  static mapping = mapping

  dataHandler: (Object) => Object

  constructor(props: StepPropsType) {
    super(props)
    this.formElementRef = createRef()
  }

  hasErrorCallback = (): void => {
    if (this.formElementRef.current) {
      const element = this.formElementRef.current.querySelector('.atp-input--has-error')
      if (element) element.scrollIntoView()
    }
  }

  previous(step: ?string = null) {
    return this.props.data.replace(this.state.data).then(() => super.previous(step))
  }
}

export default Step
